import SOURCE_ENUM from 'web/sources/SOURCE_ENUM';
import DESTINATION_ENUM from 'web/destinations/DESTINATION_ENUM';

export default Object.freeze({
  [SOURCE_ENUM.MYSQL]: 'MySQLLogo',
  [SOURCE_ENUM.POSTGRES]: 'PostgreSQLLogo',
  [SOURCE_ENUM.MARIA]: 'MariaDBLogo',
  [SOURCE_ENUM.SQLSRV]: 'SqlServerLogo',
  [SOURCE_ENUM.SALESFORCE]: 'SalesforceLogo',
  [SOURCE_ENUM.SALESFORCEV2]: 'SalesforceLogo',
  [SOURCE_ENUM.BIGCOMMERCE]: 'BigCommerceLogo',
  [SOURCE_ENUM.KLAVIYO]: 'KlaviyoLogo',
  [SOURCE_ENUM.KLAVIYO_GENERIC]: 'KlaviyoLogo',
  [SOURCE_ENUM.ALGOLIA]: 'AlgoliaLogo',
  [SOURCE_ENUM.OMNISEND]: 'OmnisendLogo',
  [SOURCE_ENUM.ADOBE_ANALYTICS]: 'AdobeLogo',
  [SOURCE_ENUM.FACEBOOK]: 'FacebookLogo',
  [SOURCE_ENUM.SHIPPO]: 'ShippoLogo',
  [SOURCE_ENUM.RECHARGE]: 'RechargeLogo',
  [SOURCE_ENUM.ONFLEET]: 'OnfleetLogo',
  [SOURCE_ENUM.GOOGLE_ANALYTICS]: 'Google',
  [SOURCE_ENUM.YOTPO]: 'YotpoLogo',
  [SOURCE_ENUM.STRIPE]: 'StripeLogo',
  [SOURCE_ENUM.BING_ADS]: 'BingLogo',
  [SOURCE_ENUM.SHOPIFY]: 'ShopifyLogo',
  [SOURCE_ENUM.EBAY]: 'EbayLogo',
  [SOURCE_ENUM.BRAINTREE]: 'BraintreeLogo',
  [SOURCE_ENUM.GOOGLE_SHEETS]: 'GoogleSheetsLogo',
  [SOURCE_ENUM.ZENDESK_CHAT]: 'ZendeskChatLogo',
  [SOURCE_ENUM.ADROLL]: 'AdrollLogo',
  [SOURCE_ENUM.LINKEDIN_ADS]: 'LinkedInLogo',
  // disabling this in line with Exchange Rates Data API (generic) implementation
  // [SOURCE_ENUM.EXCHANGERATES]: 'ExchangeRatesLogo',
  [SOURCE_ENUM.EXCHANGERATES_DATA_API]: 'ExchangeRatesDataAPILogo',
  [SOURCE_ENUM.SENDGRID]: 'SendgridLogo',
  [SOURCE_ENUM.SALESFORCE_MARKETING]: 'SalesforceLogo',
  [SOURCE_ENUM.SURVEYMONKEY]: 'SurveyMonkeyLogo',
  [SOURCE_ENUM.ZENDESKSUPPORT]: 'ZendeskSupportLogo',
  [SOURCE_ENUM.SQUARE]: 'SquareLogo',
  [SOURCE_ENUM.GOOGLE_ADS]: 'Google',
  [SOURCE_ENUM.HUBSPOT]: 'HubSpotLogo',
  [SOURCE_ENUM.SNAPCHAT]: 'SnapchatLogo',
  [SOURCE_ENUM.GORGIAS]: 'GorgiasLogo',
  [SOURCE_ENUM.DELIGHTED]: 'DelightedLogo',
  [SOURCE_ENUM.PAYPAL]: 'PayPalLogo',
  [SOURCE_ENUM.MAILCHIMP]: 'MailchimpLogo',
  [SOURCE_ENUM.PINTEREST]: 'PinterestLogo',
  [SOURCE_ENUM.TWITTER]: 'TwitterLogo',
  [SOURCE_ENUM.YOUTUBE_ANALYTICS]: 'YouTubeLogo',
  [SOURCE_ENUM.YOUTUBE]: 'YouTubeLogo',
  [SOURCE_ENUM.TIKTOK_ADS]: 'TikTokAdsLogo',
  [SOURCE_ENUM.SHIPSTATION]: 'ShipStationLogo',
  [SOURCE_ENUM.SALESFORCE_PARDOT]: 'SalesforceLogo',
  [SOURCE_ENUM.MAGENTO]: 'MagentoLogo',
  [SOURCE_ENUM.PRESTASHOP]: 'PrestaShopLogo',
  [SOURCE_ENUM.SALESFORCE_EINSTEIN]: 'SalesforceLogo',
  [SOURCE_ENUM.INTUIT_QUICKBOOKS]: 'IntuitQuickBooksLogo',
  [SOURCE_ENUM.MANDRILL]: 'MandrillLogo',
  [SOURCE_ENUM.YOTPO_LOYALTY]: 'YotpoLogo',
  [SOURCE_ENUM.FACEBOOK_PAGES]: 'FacebookLogo',
  [SOURCE_ENUM.NETSUITE]: 'NetsuiteLogo',
  [SOURCE_ENUM.JUDGEME]: 'JudgeMeLogo',
  [SOURCE_ENUM.RECURLY]: 'RecurlyLogo',
  [SOURCE_ENUM.NACELLE]: 'NacelleLogo',
  [SOURCE_ENUM.ALCHEMER]: 'AlchemerLogo',
  [SOURCE_ENUM.RINGCENTRAL]: 'RingCentralLogo',
  [SOURCE_ENUM.CYBERSOURCE]: 'CybersourceLogo',
  [SOURCE_ENUM.RETURNLY]: 'ReturnlyLogo',
  [SOURCE_ENUM.DRIP]: 'DripLogo',
  [SOURCE_ENUM.GOOGLE_SEARCH_CONSOLE]: 'Google',
  [SOURCE_ENUM.ZENVENTORY]: 'ZenventoryLogo',
  [SOURCE_ENUM.CRITEO]: 'CriteoLogo',
  [SOURCE_ENUM.MARKETO]: 'MarketoLogo',
  [SOURCE_ENUM.AIRTABLE]: 'AirtableLogo',
  [SOURCE_ENUM.GITHUB]: 'GithubLogo',
  [SOURCE_ENUM.GITLAB]: 'GitlabLogo',
  [SOURCE_ENUM.PICKZEN]: 'PickzenLogo',
  [SOURCE_ENUM.SLACK]: 'SlackLogo',
  [SOURCE_ENUM.ENQUIRELABS]: 'EnquireLabsLogo',
  [SOURCE_ENUM.VEND]: 'VendLogo',
  [SOURCE_ENUM.SMILE]: 'SmileLogo',
  [SOURCE_ENUM.AMAZON_ADS]: 'AmazonAdsLogo',
  [SOURCE_ENUM.ZENDESK_SELL]: 'ZendeskSellLogo',
  [SOURCE_ENUM.RAKUTEN_ADVERTISING]: 'RakutenAdvertisingLogo',
  [SOURCE_ENUM.AMAZON_MARKETPLACE]: 'AmazonAdsLogo',
  [SOURCE_ENUM.GA4]: 'GoogleAnalytics4Logo',
  [SOURCE_ENUM.GA360]: 'GoogleAnalytics360Logo',
  [SOURCE_ENUM.GA360_BQ_STORAGE]: 'GoogleAnalytics360Logo',
  [SOURCE_ENUM.GA4_EXPORT]: 'GoogleAnalytics4Logo',
  [DESTINATION_ENUM.REDSHIFT]: 'RedshiftLogo',
  [DESTINATION_ENUM.SNOWFLAKE]: 'SnowflakeLogo',
  [DESTINATION_ENUM.S3]: 'S3Logo',
  [DESTINATION_ENUM.BIGQUERY]: 'BigQueryLogo',
});
